import {User} from '../../state/actions'

export default class transfer {

  static run() {
    return function(dispatch, getState) {

      const actions = []
      for (let i = 0; i < localStorage.length; ++i) {
        if (localStorage.key(i).startsWith('transfer:')) actions.push(localStorage.key(i))
      }

      for (let i = 0; i < actions.length; i++) {
        const action = localStorage.getItem(actions[i])
        let payload
        try {
          payload = JSON.parse(action)
        } catch (e) {
          console.warn(e)
          continue
        }
        switch (actions[i].substr(9)) {
          case 'login':
            dispatch(User.logOut(false))
            dispatch(User.setFirstTime(
              payload.id,
              payload.email,
              payload.missingProfileInformation || [],
              payload.name,
              payload.lastName,
              payload.permissions || [],
              payload.token,
              payload.profilePicture,
              payload.fbUser || false,
              false,
            ))
            break
          case 'logout':
            dispatch(User.logOut(false))
            break
          default:
        }
        localStorage.removeItem(actions[i])
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/transfer/transfer.js